var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _vm.revendedora.precadastro_id
        ? _c("b-card-header", { staticClass: "mb-2" }, [
            _c("b", [
              _vm._v(
                "Importando pré-cadastro " +
                  _vm._s(_vm.revendedora.precadastro_id)
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form",
        { staticClass: "mt-3", on: { submit: _vm.saveRevendedora } },
        [
          _c(
            "b-tabs",
            {
              attrs: { "content-class": "mt-3", justified: "" },
              model: {
                value: _vm.tabForm,
                callback: function($$v) {
                  _vm.tabForm = $$v
                },
                expression: "tabForm"
              }
            },
            [
              _c(
                "b-tab",
                { attrs: { title: "Dados", active: "" } },
                [
                  _vm.distribuidor_codigo == "0061388" &&
                  (!_vm.revendedora.id ||
                    (_vm.revendedora.id > 0 &&
                      _vm.revendedora.indicada_por > 0))
                    ? _c(
                        "b-form-group",
                        {
                          staticClass: "mb-0",
                          attrs: {
                            label: "Cadastro Indicado Por:",
                            "label-for": "indicada-por",
                            "label-class": "font-weight-bold pt-0"
                          }
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              disabled: _vm.revendedora.id > 0,
                              options: _vm.optionsRevend
                            },
                            model: {
                              value: _vm.revendedora.indicada_por,
                              callback: function($$v) {
                                _vm.$set(_vm.revendedora, "indicada_por", $$v)
                              },
                              expression: "revendedora.indicada_por"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.pdvs.length > 0
                    ? _c(
                        "b-form-group",
                        {
                          staticClass: "mb-0",
                          attrs: {
                            label: "Ponto de Venda",
                            "label-for": "indicada-por",
                            "label-class": "font-weight-bold pt-0"
                          }
                        },
                        [
                          _c("b-form-select", {
                            attrs: { options: _vm.optionsPDV },
                            model: {
                              value: _vm.revendedora.pdv,
                              callback: function($$v) {
                                _vm.$set(_vm.revendedora, "pdv", $$v)
                              },
                              expression: "revendedora.pdv"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6", sm: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Nome:",
                                "label-for": "nome",
                                "label-cols-sm": "3",
                                "label-align": "right"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "nome", placeholder: "Nome" },
                                model: {
                                  value: _vm.revendedora.nome,
                                  callback: function($$v) {
                                    _vm.$set(_vm.revendedora, "nome", $$v)
                                  },
                                  expression: "revendedora.nome"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "6", sm: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                description:
                                  _vm.classe_distribuidor === "G"
                                    ? "O CPF deve ser preenchido"
                                    : "",
                                label: "CPF:",
                                "label-cols-sm": "3",
                                "label-align": "right",
                                "label-for": "cpf",
                                "valid-feedback": "CPF Válido",
                                "invalid-feedback": _vm.invalidCpf,
                                state: _vm.stateCPF
                              }
                            },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: "###.###.###-##",
                                    expression: "'###.###.###-##'"
                                  }
                                ],
                                attrs: { id: "cpf", state: _vm.stateCPF },
                                model: {
                                  value: _vm.revendedora.cpf,
                                  callback: function($$v) {
                                    _vm.$set(_vm.revendedora, "cpf", $$v)
                                  },
                                  expression: "revendedora.cpf"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6", sm: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Ativa:",
                                "label-for": "ativa",
                                "label-cols-sm": "3",
                                "label-align": "right"
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: { id: "desconto", options: _vm.status },
                                model: {
                                  value: _vm.revendedora.status,
                                  callback: function($$v) {
                                    _vm.$set(_vm.revendedora, "status", $$v)
                                  },
                                  expression: "revendedora.status"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "6", sm: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "E-mail:",
                                "label-for": "email",
                                "label-cols-sm": "3",
                                "label-align": "right"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "email", placeholder: "E-mail" },
                                model: {
                                  value: _vm.revendedora.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.revendedora, "email", $$v)
                                  },
                                  expression: "revendedora.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6", sm: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Desconto (%):",
                                "label-for": "desconto",
                                "label-cols-sm": "3",
                                "label-align": "right"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "desconto", type: "number" },
                                model: {
                                  value: _vm.revendedora.desconto,
                                  callback: function($$v) {
                                    _vm.$set(_vm.revendedora, "desconto", $$v)
                                  },
                                  expression: "revendedora.desconto"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "6", sm: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "RG:",
                                "label-for": "rg",
                                "label-cols-sm": "3",
                                "label-align": "right"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "rg", placeholder: "RG" },
                                model: {
                                  value: _vm.revendedora.rg,
                                  callback: function($$v) {
                                    _vm.$set(_vm.revendedora, "rg", $$v)
                                  },
                                  expression: "revendedora.rg"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6", sm: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Data Nasc.:",
                                "label-for": "dataNc",
                                "label-cols-sm": "3",
                                "label-align": "right"
                              }
                            },
                            [
                              _c("date-picker", {
                                attrs: {
                                  id: "dataNc",
                                  config: _vm.datePickerConfig
                                },
                                model: {
                                  value: _vm.revendedora.data_nasc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.revendedora, "data_nasc", $$v)
                                  },
                                  expression: "revendedora.data_nasc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6", sm: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "CEP:",
                                "label-for": "cep",
                                "label-cols-sm": "3",
                                "label-align": "right"
                              }
                            },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: "## ###-###",
                                    expression: "'## ###-###'"
                                  }
                                ],
                                attrs: { id: "cep", placeholder: "CEP" },
                                on: { keyup: _vm.buscacep },
                                model: {
                                  value: _vm.revendedora.cep,
                                  callback: function($$v) {
                                    _vm.$set(_vm.revendedora, "cep", $$v)
                                  },
                                  expression: "revendedora.cep"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "6", sm: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Logradouro:",
                                "label-for": "logradouro",
                                "label-cols-sm": "3",
                                "label-align": "right"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "logradouro",
                                  placeholder: "Logradouro"
                                },
                                model: {
                                  value: _vm.revendedora.logradouro,
                                  callback: function($$v) {
                                    _vm.$set(_vm.revendedora, "logradouro", $$v)
                                  },
                                  expression: "revendedora.logradouro"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6", sm: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-for": "bairro",
                                label: "Bairro:",
                                "label-cols-sm": "3",
                                "label-align": "right"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: { id: "bairro", placeholder: "Bairro" },
                                model: {
                                  value: _vm.revendedora.bairro,
                                  callback: function($$v) {
                                    _vm.$set(_vm.revendedora, "bairro", $$v)
                                  },
                                  expression: "revendedora.bairro"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "6", sm: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-for": "complemento",
                                label: "Complemento:",
                                "label-cols-sm": "3",
                                "label-align": "right"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "complemento",
                                  placeholder: "Complemento"
                                },
                                model: {
                                  value: _vm.revendedora.complemento,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.revendedora,
                                      "complemento",
                                      $$v
                                    )
                                  },
                                  expression: "revendedora.complemento"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6", sm: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-for": "cidade",
                                label: "Cidade:",
                                "label-cols-sm": "3",
                                "label-align": "right"
                              }
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.revendedora.cidade,
                                      expression: "revendedora.cidade"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    name: "",
                                    id: "cidade",
                                    disabled: ""
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.revendedora,
                                        "cidade",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "-1", disabled: "" } },
                                    [_vm._v("Selecione Cidade")]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.cidades, function(cidade, c) {
                                    return _c(
                                      "option",
                                      {
                                        key: c,
                                        domProps: { value: cidade.ibge }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(cidade.nome) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "6", sm: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                "label-for": "estado",
                                label: "Estado:",
                                "label-cols-sm": "3",
                                "label-align": "right"
                              }
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.revendedora.estado,
                                      expression: "revendedora.estado"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    name: "",
                                    id: "estado",
                                    disabled: ""
                                  },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.revendedora,
                                          "estado",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      _vm.getCidades
                                    ]
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "-1", disabled: "" } },
                                    [_vm._v("Selecione Estado")]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.estados, function(estado, e) {
                                    return _c(
                                      "option",
                                      {
                                        key: e,
                                        domProps: { value: estado.uf }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(estado.nome) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.distribuidor_codigo == "0667668" ||
                  _vm.distribuidor_codigo == "0667814" ||
                  _vm.distribuidor_codigo == "1966612"
                    ? _c(
                        "b-row",
                        { staticClass: "pedido-pessoal" },
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "mt-3",
                                  attrs: {
                                    "label-for": "empresa",
                                    label: "Empresa:",
                                    "label-cols-sm": "3",
                                    "label-align": "right"
                                  }
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: { options: _vm.optionsEmpresa },
                                    model: {
                                      value: _vm.revendedora.empresa,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.revendedora,
                                          "empresa",
                                          $$v
                                        )
                                      },
                                      expression: "revendedora.empresa"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "mt-3",
                                  attrs: {
                                    "label-for": "local",
                                    label: "Entrega:",
                                    "label-cols-sm": "3",
                                    "label-align": "right"
                                  }
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: { options: _vm.optionsEntrega },
                                    model: {
                                      value: _vm.revendedora.local_entrega,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.revendedora,
                                          "local_entrega",
                                          $$v
                                        )
                                      },
                                      expression: "revendedora.local_entrega"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Telefones" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "success" },
                      on: { click: _vm.addContato }
                    },
                    [_c("i", { staticClass: "fa fa-plus" }), _vm._v(" Contato")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.revendedora.contatos, function(contato, index) {
                    return _c("div", { key: index, staticClass: "row mt-3" }, [
                      _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                        _c("label", { attrs: { for: "" } }, [_vm._v("Tipo")]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: contato.tipo,
                                expression: "contato.tipo"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { name: "", id: "" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  contato,
                                  "tipo",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "F" } }, [
                              _vm._v("Fixo")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "M" } }, [
                              _vm._v("Móvel")
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                        _c("label", { attrs: { for: "" } }, [_vm._v("Numero")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: ["(##) ####-####", "(##) #####-####"],
                              expression:
                                "['(##) ####-####', '(##) #####-####']"
                            },
                            {
                              name: "model",
                              rawName: "v-model",
                              value: contato.numero,
                              expression: "contato.numero"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: contato.numero },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(contato, "numero", $event.target.value)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-6 col-sm-12" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Whatsapp")
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: contato.whatsapp,
                                expression: "contato.whatsapp"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { name: "", id: "" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  contato,
                                  "whatsapp",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { domProps: { value: 0 } }, [
                              _vm._v("Não")
                            ]),
                            _vm._v(" "),
                            _c("option", { domProps: { value: 1 } }, [
                              _vm._v("Sim")
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-6 col-sm-12 mt-3" }, [
                        _c("p", { staticClass: "btn-remove-contato" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-danger",
                              on: {
                                click: function($event) {
                                  return _vm.removeContato(index)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-trash-alt" })]
                          )
                        ])
                      ])
                    ])
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm.revendedora.id
                ? _c(
                    "b-tab",
                    { attrs: { title: "Usuário Revenda" } },
                    [
                      _c(
                        "b-row",
                        { staticClass: "mb-3 ml-3" },
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { name: "check-button", switch: "" },
                                  on: { change: _vm.limpaAcessoApp },
                                  model: {
                                    value: _vm.revendedora.loginApp,
                                    callback: function($$v) {
                                      _vm.$set(_vm.revendedora, "loginApp", $$v)
                                    },
                                    expression: "revendedora.loginApp"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Acesso a Revenda\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", [_vm._v("CPF")]),
                              _vm._v(" "),
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: "###########",
                                    expression: "'###########'"
                                  }
                                ],
                                attrs: {
                                  disabled: _vm.revendedora.loginApp === false,
                                  autofocus: ""
                                },
                                model: {
                                  value: _vm.revendedora.acessoCPF,
                                  callback: function($$v) {
                                    _vm.$set(_vm.revendedora, "acessoCPF", $$v)
                                  },
                                  expression: "revendedora.acessoCPF"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", [_vm._v("Senha")]),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: {
                                  disabled: _vm.revendedora.loginApp === false,
                                  type: "password"
                                },
                                model: {
                                  value: _vm.revendedora.senha_app,
                                  callback: function($$v) {
                                    _vm.$set(_vm.revendedora, "senha_app", $$v)
                                  },
                                  expression: "revendedora.senha_app"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", [_vm._v("Confirma Senha")]),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: {
                                  disabled: _vm.revendedora.loginApp === false,
                                  type: "password"
                                },
                                model: {
                                  value: _vm.revendedora.confirmaSenha_app,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.revendedora,
                                      "confirmaSenha_app",
                                      $$v
                                    )
                                  },
                                  expression: "revendedora.confirmaSenha_app"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.revendedora.id
                ? _c(
                    "b-tab",
                    { attrs: { title: "Usuário APP" } },
                    [
                      _c(
                        "b-row",
                        { staticClass: "mb-3 ml-3" },
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  attrs: { switch: "" },
                                  on: {
                                    change: function($event) {
                                      return _vm.limpaAcessoApp()
                                    }
                                  },
                                  model: {
                                    value: _vm.revendedora.app.ativo,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.revendedora.app,
                                        "ativo",
                                        $$v
                                      )
                                    },
                                    expression: "revendedora.app.ativo"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Acesso ao Aplicativo\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", [_vm._v("Senha")]),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: {
                                  disabled: !_vm.revendedora.app.ativo,
                                  type: "password"
                                },
                                model: {
                                  value: _vm.revendedora.app.senha,
                                  callback: function($$v) {
                                    _vm.$set(_vm.revendedora.app, "senha", $$v)
                                  },
                                  expression: "revendedora.app.senha"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", [_vm._v("Confirma Senha")]),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: {
                                  disabled: !_vm.revendedora.app.ativo,
                                  type: "password"
                                },
                                model: {
                                  value: _vm.revendedora.app.confirma,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.revendedora.app,
                                      "confirma",
                                      $$v
                                    )
                                  },
                                  expression: "revendedora.app.confirma"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c379263", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c379263","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/revendedora/form.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0c379263","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/revendedora/form.vue
// module chunks = 2